import { AnyAction } from 'redux';

import { BrandsReceivedAction, BRANDS_RECEIVED } from '@ttstr/actions/brands';
import { Articles, IndexedBrands, Product } from '@ttstr/api';
import { AppState } from '.';

export interface ReduxState {
  brandsReceived: boolean;
  brands: IndexedBrands;
}

const initialState: ReduxState = {
  brandsReceived: false,
  brands: {},
};

const brands = (state: ReduxState = initialState, action: AnyAction): ReduxState => {
  switch (action.type) {
    case BRANDS_RECEIVED: {
      const { brands } = (action as BrandsReceivedAction).payload;

      if (!brands) return state;

      return {
        ...state,
        brandsReceived: true,
        brands: brands.reduce(
          (previous, current) => ({
            ...previous,
            [current.id]: current,
          }),
          {}
        ),
      };
    }
    default:
      return state;
  }
};

export const getBrands = (state: AppState) => {
  return state.Brands.brands;
};

export const getBrandsReceived = (state: AppState) => {
  return state.Brands.brandsReceived;
};

export const getBrandsFromProduct = (brands: IndexedBrands, product: Product) => {
  if (!product) return [];
  if (!product.brand_ids) return [];

  return product.brand_ids.map((id) => brands[id]);
};

export const getBrandsForProducts = (brands: IndexedBrands, products: Articles) => {
  if (!brands) return {};
  return Object.entries(brands).reduce<IndexedBrands>(
    (acc, [id, brand]) => (products.some((p) => p.brand_ids.includes(Number(id))) ? { ...acc, [id]: brand } : acc),
    {}
  );
};

export default brands;
